'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiSocialGooglePlus = function TiSocialGooglePlus(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.5 22.5l-1.2-0.8c-0.3-0.4-0.8-0.7-0.8-1.4s0.5-1.1 1-1.6c1.3-1 2.8-2.2 2.8-4.7s-1.5-3.8-2.3-4.5h2l2-1.2h-6.8c-1.7 0-4 0.4-5.9 1.9-1.3 1.1-2 2.8-2 4.3 0 2.5 2 5.2 5.5 5.2h1c-0.1 0.3-0.3 0.6-0.3 1.1 0 1 0.5 1.7 1 2.2-1.5 0.2-4.2 0.3-6.3 1.5-2 1.2-2.5 2.8-2.5 4 0 2.5 2.3 4.7 7 4.7 5.6 0 8.6-3.2 8.6-6.2 0-2.2-1.3-3.2-2.8-4.5z m-4.2-3.7c-2.8 0-4.1-3.6-4.1-5.8 0-0.8 0.1-1.7 0.6-2.5 0.5-0.7 1.5-1.2 2.4-1.2 2.6 0 4.1 3.7 4.1 6 0 0.7 0 1.7-0.8 2.4-0.5 0.6-1.5 1.1-2.2 1.1z m0 13.2c-3.5 0-5.8-1.7-5.8-4s2.2-3.2 2.8-3.3c1.4-0.5 3.2-0.5 3.5-0.5h0.9c2.5 1.8 3.5 2.6 3.5 4.3 0 2-1.7 3.5-4.9 3.5z m11-12h-3.3v-1.7h3.3v-3.1l1.7-0.2v3.3h3.3v1.7h-3.3v3.3h-1.7z' })
        )
    );
};

exports.default = TiSocialGooglePlus;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/social-google-plus.js
// module id = 3719
// module chunks = 0